function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 558
// module chunks = 3